import React, { Fragment, useState, useEffect, useRef } from "react";
import PrimeLayout from "../../components/PrimeLayout";
import { Grid } from "@mui/material";
import StyledButton from "../../components/elements/StyledButton";
import StyledTable from "../../components/StyledTable";
import { userGroupHeadCells } from "../../constants/Data";
import Pagination from "../../components/elements/Pagination";
import { BackDrop } from "../../components/elements/Loader";
import { MdLibraryAdd } from "react-icons/md";
import {
  getAllUserGroups,
  setActiveInactiveGroup,
} from "../../services/api/users.api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import moment from "moment";
import UserGroupModal from "../../components/GroupsModal";
import DialogWrapper from "../../components/DialogWrapper";
import PrimarySearchBar from "../../components/PrimarySearchBar";
import styled from "styled-components";

const TextFiled = styled.div`
  font-size: 16px;
  color: #707070;
  font-family: 'Open Sans';
`;

const ConfrimTextWrapper = styled.div`
  margin-left: 14px;
  font-family: 'Open Sans';
  font-size: 16px;
  color: #707070;
`;

export default function UserGroup() {
  const [loading, setLoading] = useState(true);
  const [reRender, setReRender] = useState(false);
  const [name, setName] = useState("init");
  const [groups, setGroups] = useState({});
  const [openAction, setOpenAction] = useState(false);
  const [openEditGroup, setOpenEditGroup] = useState(false);
  const [page, setPage] = useState(1);
  const [groupRows, setGroupRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState();
  const [selectedPermissions, setSelectedPermissions] = useState();
  const [selectedCountries, setSelectedCountries] = useState();
  const [openConfirmation, setOpenConfirmation] =useState(false);
  const [activateGroup, setActivateGroup] = useState({});
  const nameRef = useRef(name);

  const navigate = useNavigate();
  const getPage = (p) => {
    setPage(p);
  };
  const user = JSON.parse(localStorage.getItem("user"));
  useEffect(() => {
    if (user) {
      if (user?.user_role !== "admin" && user?.user_role !== "super_admin") {
        toast.error("You do not have access to this page");
        return navigate("/new-upload");
      }
    }
  }, [user, navigate]);

  useEffect(() => {
    nameRef.current = name;
  }, [name]);

  useEffect(() => {
    getGroups();
  }, [page, reRender, navigate]);

  const getGroups = async () => {
    try {
      setLoading(true);
      const groupData = await getAllUserGroups(
        page,
        10,
        nameRef.current,
      );
      const rows = groupData?.docs?.map((group) => {
        let data = {};
        data.id = group._id
        data.group_name = group.group_name;
        data.allocated_users = group?.users?.length.toString();
        data.created_at = moment(group.created_at).format("DD/MM/YYYY, HH:mm");
        data.created_by = group.created_by;
        data.is_active = group.is_active;
        return data;
      });
      setGroupRows([...rows]);
      setGroups(groupData);
      if(name !== "" && rows?.length === 0) {
        toast.warning("Sorry, no match found for the search criteria.", {
          theme: "colored",
        });
      }
      if(name === "init" && rows?.length === 0) {
        toast.warning("No user groups created.", {
          theme: "colored",
        });
      }
      setTimeout(() => {
        setLoading(false);
      }, 800);
    } catch (err) {
      if (err.message === "No active account") {
        toast.error("Session Expired, Please Log back", {
          theme: "colored",
        });
        navigate("/");
      }
      setTimeout(() => {
        setLoading(false);
      }, 800);
    }
  };

  const toggleGroup = async (data) => {
    setOpenConfirmation(false);
    try {
      const toggle = await setActiveInactiveGroup(data.id);
      const updateRow = groupRows.map((row) => {
        if (row.id === data.id) {
          row.is_active = row.is_active ? false : true;
        }
        return row;
      });
      setGroupRows([...updateRow]);
      if (toggle.is_active)
        return toast.success(`${data.group_name} is now active`, {
          theme: "colored",
        });
      if (!toggle.is_active)
        return toast.warning(`${data.group_name} is now inactive`, {
          theme: "colored",
        });
    } catch (err) {
      toast.error(err.message, {
        theme: "colored",
      });
    }
  };

  const handleEditGroup = async (e) => {
    setOpenEditGroup(true);
    const selectedGroup = groups?.docs?.find(group => group._id === e.id);
    setSelectedCountries(selectedGroup?.countries?.map((c) => c.country));
    setSelectedPermissions(selectedGroup.countries);
    setSelectedGroup(selectedGroup);
  };

  const changeState = (data) => {
    const selectedRow = groupRows?.find((group) => group.id === data.id);
    if (selectedRow?.is_active === true) {
      setOpenConfirmation(true);
      setActivateGroup(data);
    } else {
      toggleGroup(data);
    }
  };

  return (
    <Fragment>
      {isLoading ? (
        <BackDrop />
      ) : (
        <PrimeLayout title="User Groups">
          <UserGroupModal
            open={openEditGroup}
            setOpen={setOpenEditGroup}
            getGroups={getGroups}
            edit
            editCountries={selectedCountries}
            selectedPermissions={selectedPermissions}
            selectedGroup={selectedGroup}
          />
          <UserGroupModal 
            open={openAction}
            setOpen={setOpenAction}
            getGroups={getGroups}
          />
          <DialogWrapper
            title={activateGroup.is_active ? "Deactivate User Group" : "Activate User Group"}
            cancelLabel="Cancel"
            actionLabel={activateGroup.is_active ? "Deactivate" : "Activate"}
            actionRed
            small
            open={openConfirmation}
            acceptButton={() => {
              toggleGroup(activateGroup);
            }}
            cancelAction={() => {
              setOpenConfirmation(false);
            }}
            onClose={() => {
              setOpenConfirmation(false);
            }}
          >
            <ConfrimTextWrapper>
              {`Are you sure you want to ${activateGroup.is_active ? `deactivate` : `actiavte`} this user group?`}
            </ConfrimTextWrapper>
          </DialogWrapper>

          <Grid
            container
            spacing={3}
            justifyContent={"space-between"}
            alignItems={"center"}
            align={"right"}
          >
            <Grid item xs={12} md={3} align={"left"}>
              <TextFiled>User Group</TextFiled>
              <PrimarySearchBar
                value={name === "init" ? "" : name}
                setControl={(val) => {
                  setName(val)
                }}
                handleSearchClick={() => {
                  setPage(1);
                  getGroups();
                }}
                placeholder="Search by User Group"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <StyledButton
                variant={"outlined"}
                iconLeft={<MdLibraryAdd size={20} />}
                onClick={() => {
                  setOpenAction(true);
                }}
              >
                Add New
              </StyledButton>
            </Grid>
          </Grid>
          <Grid xs={12}>
            <Fragment>
              <StyledTable
                headCells={userGroupHeadCells}
                rows={groupRows}
                slider={"is_active"}
                clickSwitch={changeState}
                editClick={handleEditGroup}
                loading={loading}
                action
              />
              {groups.totalPages > 1 && !loading && (
                <Pagination
                  count={groups.totalPages}
                  getPage={getPage}
                  page={page}
                />
              )}
            </Fragment>
          </Grid>
        </PrimeLayout>
      )}
      <Footer />
    </Fragment>
  );
}
